import type { IHttpClient } from '@/shared/api/clients/HttpClient';
import { HttpAxiosClient } from '@/shared/api/clients/HttpAxiosClient';
import { BuergeHttpServiceProvider } from '@/buerge/api/BuergeHttpServiceProvider';

let httpClientInstance: IHttpClient;
let httpServiceProvider: BuergeHttpServiceProvider;

export const useBuergeApi = (): BuergeHttpServiceProvider => {
  if (!httpClientInstance) {
    httpClientInstance = new HttpAxiosClient();
    httpServiceProvider = new BuergeHttpServiceProvider(httpClientInstance);
  }

  return httpServiceProvider;
};
